<div *ngIf="type === 'STRING' || type === 'NUMBER'">
  <label class="flex items-center gap-2 mb-1.5 text-xs cursor-pointer select-none">
    <input
      type="checkbox"
      class="cursor-pointer"
      [checked]="isNull"
      (change)="onToggle($any($event.target).checked)"
    />
    <span>No default (null)</span>
  </label>

  <input
    *ngIf="type === 'STRING'"
    [class]="inputClass"
    [disabled]="isNull"
    [ngModel]="isNull ? '' : value"
    (ngModelChange)="onValueInput($event)"
    autocomplete="off"
  />

  <input
    *ngIf="type === 'NUMBER'"
    type="number"
    [class]="inputClass"
    [disabled]="isNull"
    [ngModel]="isNull ? null : value"
    (ngModelChange)="onValueInput($event)"
    autocomplete="off"
  />
</div>
